import { render, staticRenderFns } from "./TableConflictsModal.vue?vue&type=template&id=fb7f878a"
import script from "./TableConflictsModal.vue?vue&type=script&lang=js"
export * from "./TableConflictsModal.vue?vue&type=script&lang=js"
import style0 from "./TableConflictsModal.vue?vue&type=style&index=0&id=fb7f878a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports